import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SubscribeService } from 'src/app/components/subscribe/subscribe.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  newsletterForm: FormGroup;
  isSubmitting = false;

  constructor(
    private formBuilder: FormBuilder,
    private subscribeService: SubscribeService,
    private messageService: MessageService
  ) {
    this.newsletterForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onNewsletterSubmit() {
    if (this.newsletterForm.valid) {
      this.isSubmitting = true;
      const body = {
        name: this.newsletterForm.value.name,
        subscriberEmail: this.newsletterForm.value.email,
        subscriptionSource: 'Footer Newsletter'
      };

      this.subscribeService.subscribeToBlog(body).subscribe({
        next: (res) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Newsletter subscription successful!'
          });
          this.isSubmitting = false;
          this.newsletterForm.reset();
        },
        error: (err) => {
          let errorMessage = 'Subscription failed';
          if (err.status === 409) {
            errorMessage = 'You have already subscribed.';
          }

          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: errorMessage
          });
          this.isSubmitting = false;
          this.newsletterForm.reset();
        }
      });
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please fill out all fields correctly'
      });
    }
  }
}
